import $ from 'jquery';

export function activateTabContainingElement(element) {
  if (!element) {
    return;
  }

  const inactiveTabPane = element.closest('.tab-pane:not(.active)[id]');

  if (inactiveTabPane) {
    const tabButton = $(
      `a[data-toggle="tab"][href="#${inactiveTabPane.id}"], button[data-toggle="tab"][data-target="#${inactiveTabPane.id}"]`
    )[0];

    if (tabButton) {
      tabButton.click();
    }
  }
}
